import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom"

import HomePage from './pages/homepage/HomePage'
import SpecialityChem from './pages/specialitychem/SpecialityChem'
import BulkDrug from './pages/bulkdrug/BulkDrug'
import Services from './pages/sectionservice/Services'
import AboutPage from './pages/aboutpage/AboutPage'
import Career from './pages/career/Career'
import ContactPage from './pages/contactpage/ContactPage'

// Pages

import SPaper from './pages/specialitychem/specialproduct/paper/SPaper'
import Oil from './pages/specialitychem/specialproduct/oil/Oil'
import SpTextile from './pages/specialitychem/specialproduct/sptextile/SpTextile'
import SpMining from './pages/specialitychem/specialproduct/spmining/SpMining'
import SpWater from './pages/specialitychem/specialproduct/spindwater/SpWater'
import WaterSp from './pages/specialitychem/specialproduct/spwater/WaterSp'
import Clarification from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/Clarification'
import Rishfloc1 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishfloc1/Rishfloc1'
import Rishfloc2 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishfloc2/Rishfloc2'
import RishLyte1 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishLyte1/RishLyte1'
import RishLyte2 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishLyte2/RishLyte2'
import RishLyte3 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishLyte3/RishLyte3'
import RishLyte4 from './pages/specialitychem/specialproduct/spwater/spwaterproduct/clarification/rishLyte4/RishLyte4'
import Biological from './pages/specialitychem/specialproduct/spwater/spwaterproduct/biological/Biological'
import Biorishzym from './pages/specialitychem/specialproduct/spwater/spwaterproduct/biological/biorishzym/Biorishzym'
import Scale from './pages/specialitychem/specialproduct/spwater/spwaterproduct/scale/Scale'
import Richscale from './pages/specialitychem/specialproduct/spwater/spwaterproduct/scale/richscale/Richscale'
import FoamControl from './pages/specialitychem/specialproduct/spwater/spwaterproduct/foamcontrol/FoamControl'
import RichFoam from './pages/specialitychem/specialproduct/spwater/spwaterproduct/foamcontrol/richfoam/RichFoam'
import Sugar from './pages/specialitychem/specialproduct/sugar/Sugar'
import Ceramic from './pages/specialitychem/specialproduct/ceramic/Ceramic'
import CeramicProduct from './pages/specialitychem/specialproduct/ceramic/ceramicproduct/CeramicProduct'
import Methyl from './pages/bulkdrug/bulkdrugproduct/methyl/Methyl'
import Technical from './pages/bulkdrug/bulkdrugproduct/methyl/methylproduct/technical/Technical'
import FF from './pages/bulkdrug/bulkdrugproduct/methyl/methylproduct/f&f/FF'
import Octyl from './pages/bulkdrug/bulkdrugproduct/octyl/Octyl'
import Salicylamide from './pages/bulkdrug/bulkdrugproduct/salicylamide/Salicylamide'
import Salicylic from './pages/bulkdrug/bulkdrugproduct/salicylic/Salicylic'
import SalicylicTechnical from './pages/bulkdrug/bulkdrugproduct/salicylic/salicylicproduct/technical/SalicylicTechnical'
import PharmaSalicylic from './pages/bulkdrug/bulkdrugproduct/salicylic/salicylicproduct/pharmasalicylic/PharmaSalicylic'
import Aspirin from './pages/bulkdrug/bulkdrugproduct/aspirin/Aspirin'


// Instruements Pages
// import PaperPulp from './pages/instrument/paperpulp/PaperPulp'
import WetendQC from './pages/instrument/paperpulp/wetend/WetendQC'

import PackagingTesting from './pages/instrument/packagingtesting/PackagingTesting'
import RD from './pages/instrument/RD/RD'
import WaterWaste from './pages/instrument/waterwaste/WaterWaste'

import Industrial from './pages/instrument/industrial/Industrial'


//sperate pages routes
import Roughnessporocity from './pages/instrument/paperpulp/paperpluppage/automatictesting/roughness/Roughnessporocity'
import Profitgloss from './pages/instrument/paperpulp/paperpluppage/automatictesting/profit/Profitgloss'
import Burst from './pages/instrument/paperpulp/paperpluppage/automatictesting/burst/Burst'
import Thickness from './pages/instrument/paperpulp/paperpluppage/automatictesting/thickness/Thickness'
import SampleCutter from './pages/instrument/paperpulp/paperpluppage/samplepreparation/samplecutter/SampleCutter'
import PeneumaticCutter from './pages/instrument/paperpulp/paperpluppage/samplepreparation/peneumaticcutter/PeneumaticCutter'
import DoubleBladeCutter from './pages/instrument/paperpulp/paperpluppage/samplepreparation/doublebladecutter/DoubleBladeCutter'
import CompressionTester from './pages/instrument/paperpulp/paperpluppage/corrugatedboardtesting/compressiontester/CompressionTester'
import BoxCompressionTest from './pages/instrument/paperpulp/paperpluppage/corrugatedboardtesting/boxcompressiontest/BoxCompressionTest'
import InternalBod from './pages/instrument/paperpulp/paperpluppage/corrugatedboardtesting/internalbond/InternalBond'
import PenuematicPress from './pages/instrument/paperpulp/paperpluppage/pulptesting/penuematicpress/PenuematicPress'
import FiberClassifier from './pages/instrument/paperpulp/paperpluppage/pulptesting/fiberclassifier/FiberClassifier'
import ManualSheetFormer from './pages/instrument/paperpulp/paperpluppage/pulptesting/manualsheetformer/ManualSheetFormer'
import PFIMill from './pages/instrument/paperpulp/paperpluppage/pulptesting/pfimill/PFIMill'
import ChargeAnalyserSystem from './pages/instrument/paperpulp/paperpluppage/pulptesting/chargeanalysersystem/ChargeAnalyserSystem'
import FiberPotentialAnalyser from './pages/instrument/paperpulp/paperpluppage/pulptesting/fiberpontenanalyser/FiberPotentialAnalyser'
import AutomatedGram from './pages/instrument/paperpulp/paperpluppage/pulptesting/automatedgram/AutomatedGram'
import AutomatedCaliper from './pages/instrument/paperpulp/paperpluppage/pulptesting/automatedcaliper/AutomatedCaliper'
import AutomatedCaliperPp from './pages/instrument/paperpulp/paperpluppage/pulptesting/automatedcaliperpp/AutomatedCaliperPp'
import AutomatedCaliperTSA from './pages/instrument/paperpulp/paperpluppage/pulptesting/automatedcalipertsa/AutomatedCaliperTSA'
import PortableMoistureMeters from './pages/instrument/paperpulp/paperpluppage/pulptesting/portablemoisturemeters/PortableMoistureMeters'
import LaboratoryBeater from './pages/instrument/paperpulp/paperpluppage/pulptesting/laboratorybeater/LaboratoryBeater'
import MoistureMeter from './pages/instrument/paperpulp/paperpluppage/pulptesting/moisturemeter/MoistureMeter'
import TactileSensation from './pages/instrument/textile/textilepages/tactilesensation/TactileSensation'
import AbsorbencyTester from './pages/instrument/textile/textilepages/absorbencytester/AbsorbencyTester'
import ChargeAnalyserFibrePotential from './pages/instrument/textile/textilepages/chargeanalyserfibrepotential/ChargeAnalyserFibrePotential'
import SurfaceHardnessAbrasionTester from './pages/instrument/textile/textilepages/surfacehardnessabrasiontester/SurfaceHardnessAbrasionTester'
import ElectronicCrockMeter from './pages/instrument/textile/textilepages/electroniccrockmeter/ElectronicCrockMeter'
import PillingTester from './pages/instrument/textile/textilepages/pillingtester/PillingTester'
import TextileAbrasionTester from './pages/instrument/textile/textilepages/abrasiontester/TextileAbrasionTester'
import TextileMartindaleAbrasionTester from './pages/instrument/textile/textilepages/martindaleabrasiontester/TextileMartindaleAbrasionTester'
import OpticalFilmAbrasionTester from './pages/instrument/textile/textilepages/opticalfilmabrasiontester/OpticalFilmAbrasionTester'
import DyeingRubbingTester from './pages/instrument/textile/textilepages/dyeingrubbingtester/DyeingRubbingTester'
import HydrostaticHeadTesterTarpaulin from './pages/instrument/textile/textilepages/hydrostaticheadtestertarpaulin/HydrostaticHeadTesterTarpaulin'
import TextileHydrostaticHeadTester from './pages/instrument/textile/textilepages/hydrostaticheadtester/TextileHydrostaticHeadTester'
import MotorTwistCounterYarn from './pages/instrument/textile/textilepages/motortwistcounteryarn/MotorTwistCounterYarn'
import YarnInspectorMotor from './pages/instrument/textile/textilepages/yarninspectormotor/YarnInspectorMotor'
import UniversalMaterialsTestingMachine from './pages/instrument/textile/textilepages/universalmaterialstestingmachine/UniversalMaterialsTestingMachine'
import CO2Tester from './pages/instrument/waterwaste/waterwastepages/co2tester/CO2Tester'
import AmmoniumProb from './pages/instrument/waterwaste/waterwastepages/ammoniumprob/AmmoniumProb'
import AmmonoLab from './pages/instrument/waterwaste/waterwastepages/ammonolab/AmmonoLab'
import CODMonitor from './pages/instrument/waterwaste/waterwastepages/codmonitor/CODMonitor'
import RDChargeAnalyzerSystem from './pages/instrument/RD/rdpages/rdchargeanalyzersystem/RDChargeAnalyzerSystem'
import ZetaPotentialAnalyser from './pages/instrument/RD/rdpages/zetapotentialanalyser/ZetaPotentialAnalyser'
import ParticleSizeAnalyser from './pages/instrument/RD/rdpages/particlesizeanalyser/ParticleSizeAnalyser'
import ParticlesizeMeasurement from './pages/instrument/RD/rdpages/particlesizemeasurement/ParticlesizeMeasurement'
import PSIHighPressure from './pages/instrument/RD/rdpages/PSIhighpressure/PSIHighPressure'
import DigitalBenchtopViscometer from './pages/instrument/RD/rdpages/digitalbenchtopviscometer/DigitalBenchtopViscometer'
import ArtPhotonics from './pages/instrument/RD/rdpages/artphotonics/ArtPhotonics'
import FPA from './pages/instrument/paperpulp/wetend/wetendqcpages/fpa/FPA'
import AshContentAnalyzer from './pages/instrument/paperpulp/wetend/wetendqcpages/ashcontentanalyzer/AshContentAnalyzer'
import WetStetech from './pages/instrument/paperpulp/wetend/wetendqcpages/wetstetech/WetStetech'
import PDAhigh from './pages/instrument/paperpulp/wetend/wetendqcpages/pda/PDAhigh'
import SurfaceTesting from './pages/instrument/paperpulp/wetend/wetendqcpages/surfacetestig/SurfaceTesting'
import TSA from './pages/instrument/paperpulp/wetend/wetendqcpages/tsa/TSA'
import BurstTester from './pages/instrument/paperpulp/papertesting/papertestingpages/bursttester/BurstTester'
import Fluter from './pages/instrument/paperpulp/papertesting/papertestingpages/fluter/Fluter'
import ManualMicormeter from './pages/instrument/paperpulp/papertesting/papertestingpages/manualmicrometer/ManualMicormeter'
import Smoothness from './pages/instrument/paperpulp/papertesting/papertestingpages/smoothness/Smoothness'
import SampleCrushTester from './pages/instrument/packagingtesting/packagingtestingpages/samplecrushtester/SampleCrushTester'
import FourPointBendingTester from './pages/instrument/packagingtesting/packagingtestingpages/4pointbendingtester/FourPointBendingTester'
import PDAHighViscous from './pages/instrument/packagingtesting/packagingtestingpages/highviscous/PDAHighViscous'
import FrictionTester from './pages/instrument/packagingtesting/packagingtestingpages/frictiontester/FrictionTester'
import BurstingStrengthTester from './pages/instrument/packagingtesting/packagingtestingpages/burstingstrengthtester/BurstingStrengthTester'
import VAL from './pages/instrument/packagingtesting/packagingtestingpages/val/VAL'
import DigitalMicrometer from './pages/instrument/packagingtesting/packagingtestingpages/digitalmicrometer/DigitalMicrometer'
import CobbSizingTester from './pages/instrument/packagingtesting/packagingtestingpages/cobbsizingtester/CobbSizingTester'
import PunctureTester from './pages/instrument/packagingtesting/packagingtestingpages/puncturetester/PunctureTester'
import CircularCutter from './pages/instrument/packagingtesting/packagingtestingpages/circularcutter/CircularCutter'
import TwinBladeCutter from './pages/instrument/packagingtesting/packagingtestingpages/twinbladecutter/TwinBladeCutter'
import CorrugatedSampleCutter from './pages/instrument/packagingtesting/packagingtestingpages/corrugatedsamplecutter/CorrugatedSampleCutter'
import BoxOpening from './pages/instrument/packagingtesting/packagingtestingpages/boxopening/BoxOpening'
import Processviscometer from './pages/instrument/industrial/industrialpages/processviscometer/Processviscometer'
import ExtrusionViscometer from './pages/instrument/industrial/industrialpages/extrusionviscometer/ExtrusionViscometer'
import CoatingViscometer from './pages/instrument/industrial/industrialpages/coatingviscometer/CoatingViscometer'
import UreaAmmonium from './pages/instrument/industrial/industrialpages/ureaammonium/UreaAmmonium'
import HighPressViscometer from './pages/instrument/industrial/industrialpages/highpressviscometer/HighPressViscometer'
import FertilizerProcessAnalyser from './pages/instrument/industrial/industrialpages/fertilizerprocessanalyser/FertilizerProcessAnalyser'
import ElectroMechanicalMaterial from './pages/instrument/industrial/industrialpages/electromechanical/ElectroMechanicalMaterial'
import DrumAbrasionTester from './pages/instrument/industrial/industrialpages/drumabrasiontester/DrumAbrasionTester'
import PneumaticManualSampleCutter from './pages/instrument/industrial/industrialpages/pneumaticmanualsample/PneumaticManualSampleCutter'
import ReboundResilienceTester from './pages/instrument/industrial/industrialpages/reboundresiliencetester/ReboundResilienceTester'
import BasicComputerizedMeltIndexer from './pages/instrument/industrial/industrialpages/basiccompterizedmelt/BasicComputerizedMeltIndexer'
import OpacityMeterPlasticFlim from './pages/instrument/industrial/industrialpages/opacitymeterinplasticfilm/OpacityMeterPlasticFlim'
import SoftingPointTester from './pages/instrument/industrial/industrialpages/softingpointtester/SoftingPointTester'
import FallingDropWeight from './pages/instrument/industrial/industrialpages/fallingdrop/FallingDropWeight'
import PenetrationTest from './pages/instrument/industrial/industrialpages/penetrationtest/PenetrationTest'
import GelBloomTester from './pages/instrument/industrial/industrialpages/blomtester/GelBloomTester'
import BackExtractionTester from './pages/instrument/industrial/industrialpages/backextractiontester/BackExtractionTester'
import NotchingMachine from './pages/instrument/industrial/industrialpages/notchingmachine/NotchingMachine'
import PendulumImpactTester from './pages/instrument/industrial/industrialpages/pendulumtester/PendulumImpactTester'
import PureEarthRareMaterial from './pages/instrument/industrial/industrialpages/purearthrarematerial/PureEarthRareMaterial'
import LegalNotices from './pages/legalnotice/LegalNotices'
import PrivacyPolicy from './pages/privacypolicy/PrivacyPolicy'
import Disclaimer from './pages/disclaimer/Disclaimer'
import PaperInPaper from './pages/specialitychem/specialproduct/paper/spaperpages/Paperinpaper/PaperInPaper'
import PaperInTissue from './pages/specialitychem/specialproduct/paper/spaperpages/papertissue/PaperInTissue'
import PaperPackaging from './pages/specialitychem/specialproduct/paper/spaperpages/paperpackaging/PaperPackaging'
import PaperPaperPulp from './pages/specialitychem/specialproduct/paper/spaperpages/paperpulp/PaperPaperPulp'
import FibreClassifier from './pages/instrument/paperpulp/papertesting/papertestingpages/fibreclassifier/FibreClassifier'
import AutomaticSheetFormer from './pages/instrument/paperpulp/papertesting/papertestingpages/automaticsheetformer/AutomaticSheetFormer'
import RapidSheetDryer from './pages/instrument/paperpulp/papertesting/papertestingpages/rapidsheetdryer/RapidSheetDryer'
import PulpHomogenizer from './pages/instrument/paperpulp/papertesting/papertestingpages/pulphomogenizer/PulpHomogenizer'
import FibrePotentialAnalyzerFPA from './pages/instrument/paperpulp/papertesting/papertestingpages/fibrepotentialanalyzerfPA/FibrePotentialAnalyzerFPA'
import FiberPotentialOnilne from './pages/instrument/paperpulp/papertesting/papertestingpages/fiberpotentialonilne/FiberPotentialOnilne'
import PulpTesting from './pages/instrument/paperpulp/paperpluppage/PulpTesting'
import PaperTesting from './pages/instrument/paperpulp/papertesting/PaperTesting'
import ChargeAnalyzerSystem from './pages/instrument/paperpulp/paperpluppage/ChargeAnalyzerSystem'
import FiberPotentialAnalyzer from './pages/instrument/paperpulp/paperpluppage/FiberPotentialAnalyzer'
import FIBERZETAPOTENTIALANALYZER from './pages/instrument/paperpulp/paperpluppage/FIBERZETAPOTENTIALANALYZER'
import SurfaceSizetesting from './pages/instrument/paperpulp/paperpluppage/SurfaceSizetesting'
import PrintEvennessAnalyzer from './pages/instrument/paperpulp/paperpluppage/PrintEvennessAnalyzer'
import WetStretchmeasurementsystem from './pages/instrument/paperpulp/paperpluppage/WetStretchmeasurementsystem'
import BURSTINGSTRENGTH from './pages/instrument/paperpulp/paperpluppage/BURSTINGSTRENGTH'
import POINTBENDING from './pages/instrument/paperpulp/paperpluppage/POINTBENDING'
import INTERNALBONDTESTER from './pages/instrument/paperpulp/paperpluppage/INTERNALBONDTESTER'
import PORTABLEMOISTUREMETERS from './pages/instrument/paperpulp/paperpluppage/PORTABLEMOISTUREMETERS'
import AccuFormFormationAnalyzer from './pages/instrument/paperpulp/paperpluppage/AccuFormFormationAnalyzer'
import BoxCompressionTester from './pages/instrument/packagingtesting/packagingtestingpages/BoxCompressionTester'
import HorizontalPeelforceTesting from './pages/instrument/packagingtesting/packagingtestingpages/HorizontalPeelforceTesting'
import TorqueTestingMachine from './pages/instrument/packagingtesting/packagingtestingpages/TorqueTestingMachine'
import ElectronicDropDartImpactTester from './pages/instrument/packagingtesting/packagingtestingpages/ElectronicDropDartImpactTester'
import ManualRollerSamplePreparation from './pages/instrument/packagingtesting/packagingtestingpages/ManualRollerSamplePreparation'
import MartindaleAbrasionTester from './pages/instrument/packagingtesting/packagingtestingpages/MartindaleAbrasionTester'
import AbrasionTester from './pages/instrument/packagingtesting/packagingtestingpages/AbrasionTester'
import HydrostaticHeadTester from './pages/instrument/packagingtesting/packagingtestingpages/HydrostaticHeadTester'
import YarnInspector from './pages/instrument/packagingtesting/packagingtestingpages/YarnInspector'
import VASCO from './pages/instrument/RD/rdpages/VASCO'
import PSZMW from './pages/instrument/RD/PSZMW'
import VASCOKIN from './pages/instrument/RD/rdpages/VASCOKIN'
import WALLIS from './pages/instrument/RD/rdpages/WALLIS'
import AMERIGOAMERIGOPLUS from './pages/instrument/RD/rdpages/AMERIGOAMERIGOPLUS'
import THETIS from './pages/instrument/RD/rdpages/THETIS'
import OPTIONALACCESSORIES from './pages/instrument/RD/rdpages/OPTIONALACCESSORIES'
import Announcement from './pages/announcement/Announcement'
import ChargeAnalyserSystemRD from './pages/instrument/RD/rdpages/PARTICLECHARGEANALYSER/ChargeAnalyserSystem'
import MeltFlowIndexTester from './pages/instrument/RD/rdpages/MeltFlowIndexTester'
import SofastBV3Viscometer from './pages/instrument/RD/rdpages/SofastBV3Viscometer'
import OpticalProbesPage from './pages/instrument/RD/rdpages/OpticalProbesPage'
import ATRProbes from './pages/instrument/RD/rdpages/OPTICALPROBES/ATRProbes'
import StandardATRProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/StandardATRProbe'
import ATRProbeHarshEnv from './pages/instrument/RD/rdpages/OPTICALPROBES/ATRProbeHarshEnv'
import ATRProbeLabApplications from './pages/instrument/RD/rdpages/OPTICALPROBES/ATRProbeLabApplications'
import ATRProbeShaftDesign from './pages/instrument/RD/rdpages/OPTICALPROBES/ATRProbeShaftDesign'
import ATRLoopProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/ATRLoopProbe'
import TouchATRProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/TouchATRProbe'
import ReflectionProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/ReflectionProbe'
import DiffuseReflectionProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/DiffuseReflectionProbe'
import RamanFiberProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/RamanFiberProbe.JSX'
import RamanNeedleFiberProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/RamanNeedleFiberProbe'
import FluorescenceFiberProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/FluorescenceFiberProbe'
import TransmissionFiberProbe from './pages/instrument/RD/rdpages/OPTICALPROBES/TransmissionFiberProbe'
import TransflectionFiberProbes from './pages/instrument/RD/rdpages/OPTICALPROBES/TransflectionFiberProbes'
import MidIRFiberProbeGases from './pages/instrument/RD/rdpages/OPTICALPROBES/MidIRFiberProbeGases'
import TransflectionFiberProbesIndustrialApplications from './pages/instrument/RD/rdpages/OPTICALPROBES/TransflectionFiberProbesIndustrialApplications'
import NIRamanCombiFiberProbes from './pages/instrument/RD/rdpages/OPTICALPROBES/NIRamanCombiFiberProbes'
import Fermenters from './pages/instrument/bio/Fermenters'
import LabscaleModel from './pages/instrument/bio/fermenterspages/LabscaleModel'
import PilotScale from './pages/instrument/bio/fermenterspages/PilotScale'
import IndustrialScale from './pages/instrument/bio/fermenterspages/IndustrialScale'
import ParticleSizeAnalyserNew from './pages/instrument/bio/ParticleSizeAnalyser'
import RubberPolymerindustries from './pages/instrument/rubberPolymer/RubberPolymerindustries'
import DINAbrasionTester from './pages/instrument/rubberPolymer/DINAbrasionTester'
import SolarPanelAbrasionTester from './pages/instrument/rubberPolymer/SolarPanelAbrasionTester'
import ElectricPencilHardnessTester from './pages/instrument/rubberPolymer/ElectricPencilHardnessTester'
import MeltFlowIndexTesterNew from './pages/instrument/rubberPolymer/MeltFlowIndexTester'
import AutomaticIRHDTester from './pages/instrument/rubberPolymer/AutomaticIRHDTester'
import AutomaticMovingDieRheometer from './pages/instrument/rubberPolymer/AutomaticMovingDieRheometer'
import LabPressforrubber from './pages/instrument/rubberPolymer/LabPressforrubber'
import MooneyViscometer from './pages/instrument/rubberPolymer/MooneyViscometer'
import OscillatingDiskRheometer from './pages/instrument/rubberPolymer/OscillatingDiskRheometer'
import TensileTester from './pages/instrument/rubberPolymer/TensileTester'
import MaterialTesting from './pages/instrument/MaterialTesting/MaterialTesting'
import UTMTC from './pages/instrument/MaterialTesting/UTMTC'
import EnvironmentalChamber from './pages/instrument/MaterialTesting/EnvironmentalChamber'
import Textile from './pages/instrument/textile/Textile'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/specialalitychem' element={<SpecialityChem />} />
        <Route path='/bulk-drug' element={<BulkDrug />} />
        <Route path='/services' element={<Services />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/careers' element={<Career />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/legalnotice' element={<LegalNotices />} />
        <Route path='/Privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/Disclaimer' element={<Disclaimer />} />
        <Route path='/announcement' element={<Announcement />} />


        {/* SpecialityChem products */}
        <Route path='/spaper' element={<SPaper />} />
        <Route path='/soil' element={<Oil />} />
        <Route path='/sptextile' element={<SpTextile />} />
        <Route path='/spmining' element={<SpMining />} />
        <Route path='/spindustrywater' element={<SpWater />} />
        <Route path='/spwater' element={<WaterSp />} />
        <Route path='/spsugar' element={<Sugar />} />
        <Route path='/spceramic' element={<Ceramic />} />


        {/* SP paper  Product Routes */}
        <Route path='/spaperpaper' element={<PaperInPaper />} />
        <Route path='/spapertissue' element={<PaperInTissue />} />
        <Route path='/spaperpackaging' element={<PaperPackaging />} />
        <Route path='/spaperpaperpulp' element={<PaperPaperPulp />} />


        {/* SP Water Product Routes */}
        <Route path='/clarification' element={<Clarification />} />

        {/* SP Clarification Product Routes */}
        <Route path='/rishfloc1' element={<Rishfloc1 />} />
        <Route path='/rishfloc2' element={<Rishfloc2 />} />
        <Route path='/rishLyte1' element={<RishLyte1 />} />
        <Route path='/rishLyte2' element={<RishLyte2 />} />
        <Route path='/rishLyte3' element={<RishLyte3 />} />
        <Route path='/rishLyte4' element={<RishLyte4 />} />
        {/* SP Clarification Product Routes close */}

        <Route path='/biological' element={<Biological />} />
        <Route path='/biorishzym' element={<Biorishzym />} />
        <Route path='/scale' element={<Scale />} />
        <Route path='/rishScale' element={<Richscale />} />

        <Route path='/foamcontrol' element={<FoamControl />} />
        <Route path='/richfoam' element={<RichFoam />} />

        {/* Ceramic products */}
        <Route path='/claydisperant' element={<CeramicProduct />} />

        {/* Bulk Drug products routes */}

        <Route path='/methyl' element={<Methyl />} />
        <Route path='/technicalmethyl' element={<Technical />} />
        <Route path='/ffmethyl' element={<FF />} />
        <Route path='/pharmamethyl' element={<FF />} />

        <Route path='/octyle' element={<Octyl />} />
        <Route path='/salicylamide' element={<Salicylamide />} />
        <Route path='/salicylic' element={<Salicylic />} />
        <Route path='/techsalicylic' element={<SalicylicTechnical />} />
        <Route path='/pharmasalicylic' element={<PharmaSalicylic />} />
        <Route path='/aspirin' element={<Aspirin />} />

        {/* Instruments routes */}

        {/* <Route path='/paperpulp' element={<PaperPulp />} /> */}
        {/* Instruments routes */}
        <Route path='/PPwetendQC' element={<WetendQC />} />
        <Route path='/Pulp-Testing' element={<PaperTesting />} />
        <Route path='/Paper-Testing' element={<PulpTesting />} />

        <Route path='/packainginstruments' element={<PackagingTesting />} />
        <Route path='/industrial' element={<Industrial />} />
        <Route path='/RD-Instruments' element={<RD />} />
        <Route path='/wastewater' element={<WaterWaste />} />
        <Route path='/textile' element={<Textile />} />

        {/* separate pages routes of automatic testing */}
        <Route path='/roughnessporocity' element={<Roughnessporocity />} />
        <Route path='/profitgloss' element={<Profitgloss />} />
        <Route path='/burst' element={<Burst />} />
        <Route path='/thickness' element={<Thickness />} />

        {/* separate pages routes of sample preparation */}
        <Route path='/samplecutter' element={<SampleCutter />} />
        <Route path='/peneumacutter' element={<PeneumaticCutter />} />
        <Route path='/doubleblade' element={<DoubleBladeCutter />} />

        {/* separate pages routes of corrugated board testing */}
        <Route path='/compressiontester' element={<CompressionTester />} />
        <Route path='/peneumacutter' element={<PeneumaticCutter />} />
        <Route path='/doubleblade' element={<DoubleBladeCutter />} />
        <Route path='/boxcomptester' element={<BoxCompressionTest />} />
        <Route path='/internalbond' element={<InternalBod />} />

        {/* separate pages routes of pulp testing */}
        <Route path='/penupress' element={<PenuematicPress />} />
        <Route path='/fiberclassifier' element={<FiberClassifier />} />
        <Route path='/manualsheetformer' element={<ManualSheetFormer />} />
        <Route path='/pfimill' element={<PFIMill />} />
        <Route path='/chargeanalysersys' element={<ChargeAnalyserSystem />} />
        <Route path='/fiberpontenanalyser' element={<FiberPotentialAnalyser />} />
        <Route path='/automatedgrammage' element={<AutomatedGram />} />
        <Route path='/autocaliper' element={<AutomatedCaliper />} />
        <Route path='/autocaliperpps' element={<AutomatedCaliperPp />} />
        <Route path='/autocalipertensil' element={<AutomatedCaliperTSA />} />
        <Route path='/portablemoisture' element={<PortableMoistureMeters />} />
        <Route path='/laboratorybeater' element={<LaboratoryBeater />} />
        <Route path='/moisturemeter' element={<MoistureMeter />} />

        {/* separate pages routes of paper testing */}

        <Route path='/charge-analyzer-system' element={<ChargeAnalyzerSystem />} />
        <Route path='/fiber-potential-analyzer' element={<FiberPotentialAnalyzer />} />
        <Route path='/online-fiber-potential-analyzer' element={<FIBERZETAPOTENTIALANALYZER />} />
        <Route path='/surface-size-testing' element={<SurfaceSizetesting />} />
        <Route path='/print-evenness-analyzer-penetration-dynamics-analyzer' element={<PrintEvennessAnalyzer />} />
        <Route path='/Wet-Stretch-Measurement-System' element={<WetStretchmeasurementsystem />} />
        <Route path='/Bursting-Strngth-Tester-BT-10' element={<BURSTINGSTRENGTH />} />
        <Route path='/4-Point-Bending-Stiffness-Tester' element={<POINTBENDING />} />
        <Route path='/Internal-Bond-Tester' element={<INTERNALBONDTESTER />} />
        <Route path='/portable-moisture-meters' element={<PORTABLEMOISTUREMETERS />} />
        <Route path='/accuForm-formation-analyzer' element={<AccuFormFormationAnalyzer />} />


        {/* separate pages RD Instrument */}
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight' element={<PSZMW />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/vasco' element={<VASCO />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/vasco-kin' element={<VASCOKIN />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/wallis' element={<WALLIS />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/amerigo-amerigo-plus' element={<AMERIGOAMERIGOPLUS />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/thetis' element={<THETIS />} />
        <Route path='/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight/optical-accessories' element={<OPTIONALACCESSORIES />} />
        <Route path='/RD-Instruments/zetapotetial' element={<ZetaPotentialAnalyser />} />
        <Route path='/RD-Instruments/particle-charge-analyser/charge-analyser-system' element={<ChargeAnalyserSystemRD />} />
        <Route path='/RD-Instruments/melt-flow-index-tester' element={<MeltFlowIndexTester />} />
        <Route path='/RD-Instruments/sofast-bv3-viscometer' element={<SofastBV3Viscometer />} />
        <Route path='/RD-Instruments/optical-probes' element={<OpticalProbesPage />} />
        <Route path='/RD-Instruments/optical-probes/atr-probes' element={<ATRProbes />} />
        <Route path='/RD-Instruments/optical-probes/standard-atr-probe' element={<StandardATRProbe />} />
        <Route path='/RD-Instruments/optical-probes/atr-probe-harsh-environment' element={<ATRProbeHarshEnv />} />
        <Route path='/RD-Instruments/optical-probes/atr-probe-lab-applications' element={<ATRProbeLabApplications />} />
        <Route path='/RD-Instruments/optical-probes/atr-probe-shaft-design' element={<ATRProbeShaftDesign />} />
        <Route path='/RD-Instruments/optical-probes/atr-loop-probe' element={<ATRLoopProbe />} />
        <Route path='/RD-Instruments/optical-probes/touch-atr-probe' element={<TouchATRProbe />} />
        <Route path='/RD-Instruments/optical-probes/reflection-probe' element={<ReflectionProbe />} />
        <Route path='/RD-Instruments/optical-probes/diffuse-reflection-probe' element={<DiffuseReflectionProbe />} />
        <Route path='/RD-Instruments/optical-probes/raman-fiber-probe' element={<RamanFiberProbe />} />
        <Route path='/RD-Instruments/optical-probes/raman-needle-fiber-probe' element={<RamanNeedleFiberProbe />} />
        <Route path='/RD-Instruments/optical-probes/fluorescence-fiber-probe' element={<FluorescenceFiberProbe />} />
        <Route path='/RD-Instruments/optical-probes/transmission-fiber-probe' element={<TransmissionFiberProbe />} />
        <Route path='/RD-Instruments/optical-probes/transflection-fiber-probes' element={<TransflectionFiberProbes />} />
        <Route path='/RD-Instruments/optical-probes/mid-ir-fiber-probe-gases' element={<MidIRFiberProbeGases />} />
        <Route path='/RD-Instruments/optical-probes/transflection-fiber-probes-industrial-applications' element={<TransflectionFiberProbesIndustrialApplications />} />
        <Route path='/RD-Instruments/optical-probes/nir-raman-combi-fiber-probes' element={<NIRamanCombiFiberProbes />} />

        {/* separate pages routes of bio engineering */}
        <Route path='/bio-engineering/fermenters-bioreactorst' element={<Fermenters />} />
        <Route path='/bio-engineering/fermenters-bioreactorst/labscale-model' element={<LabscaleModel />} />
        <Route path='/bio-engineering/fermenters-bioreactorst/pilotscale-model' element={<PilotScale />} />
        <Route path='/bio-engineering/fermenters-bioreactorst/industrial-scale' element={<IndustrialScale />} />
        <Route path='/bio-engineering/partical-size-analyser' element={<ParticleSizeAnalyserNew />} />



        {/* separate pages routes of rubber polymer industries */}
        <Route path='/rubber-polymer-industries' element={<RubberPolymerindustries />} />
        <Route path='/rubber-polymer-industries/din-abrasion-tester' element={<DINAbrasionTester />} />
        <Route path='/rubber-polymer-industries/solar-panel-abrasion-tester' element={<SolarPanelAbrasionTester />} />
        <Route path='/rubber-polymer-industries/electric-pencil-hardness-tester' element={<ElectricPencilHardnessTester />} />
        <Route path='/rubber-polymer-industries/melt-flow-index-tester' element={<MeltFlowIndexTesterNew />} />
        <Route path='/rubber-polymer-industries/automatic-irhd-tester' element={<AutomaticIRHDTester />} />
        <Route path='/rubber-polymer-industries/automatic-moving-die-rheometer' element={<AutomaticMovingDieRheometer />} />
        <Route path='/rubber-polymer-industries/lab-press-for-rubber' element={<LabPressforrubber />} />
        <Route path='/rubber-polymer-industries/mooney-viscometer' element={<MooneyViscometer />} />
        <Route path='/rubber-polymer-industries/oscillating-disk-rheometer' element={<OscillatingDiskRheometer />} />
        <Route path='/rubber-polymer-industries/tensile-tester' element={<TensileTester />} />

        {/* separate pages routes of material testing */}
        <Route path='/instruments-materialtesting' element={<MaterialTesting />} />
        <Route path='/instruments-materialtesting/universal-testing-machine-with-temperature-chamber' element={<UTMTC />} />
        <Route path='/instruments-materialtesting/environmental-chamber' element={<EnvironmentalChamber />} />

        {/* separate pages routes of wet end QC */}
        <Route path='/FPAonline' element={<FPA />} />
        <Route path='/ashcontentanalyzer' element={<AshContentAnalyzer />} />
        <Route path='/wetstetch' element={<WetStetech />} />
        <Route path='/PDAhighviscous' element={<PDAhigh />} />
        <Route path='/surfacetesting' element={<SurfaceTesting />} />
        <Route path='/TSA' element={<TSA />} />

        {/* separate pages routes of paper testing */}
        <Route path='/PulpDisintegrator' element={<BurstTester />} />
        <Route path='/CanadianFreenessTester' element={<Fluter />} />
        <Route path='/PneumaticFreenessTesterSchooper-Riegler' element={<ManualMicormeter />} />
        <Route path='/PFIMill-LaboratoryBeater' element={<Smoothness />} />
        <Route path='/fibreclassifier' element={<FibreClassifier />} />
        <Route path='/automaticsheetformer' element={<AutomaticSheetFormer />} />
        <Route path='/rapidsheetdryer' element={<RapidSheetDryer />} />
        <Route path='/pulphomogenizer' element={<PulpHomogenizer />} />
        <Route path='/fibrepotentialanalyzerfPA' element={<FibrePotentialAnalyzerFPA />} />
        <Route path='/fiberpotentialonilne' element={<FiberPotentialOnilne />} />


        {/* separate pages routes of packaging testing */}
        <Route path='/samplescrushtester' element={<SampleCrushTester />} />
        <Route path='/4pointbendingtester' element={<FourPointBendingTester />} />
        <Route path='/PDAhighviscous' element={<PDAHighViscous />} />
        <Route path=' ' element={<FrictionTester />} />
        <Route path='/burstingstrengthtester' element={<BurstingStrengthTester />} />
        <Route path='/VAL' element={<VAL />} />
        <Route path='/digitalmicrometer' element={<DigitalMicrometer />} />
        <Route path='/cobbsizingtester' element={<CobbSizingTester />} />
        <Route path='/digitalpuncture' element={<PunctureTester />} />
        <Route path='/circularcutter' element={<CircularCutter />} />
        <Route path='/twinbladercutter' element={<TwinBladeCutter />} />
        <Route path='/corrugatedsamplecutter' element={<CorrugatedSampleCutter />} />
        <Route path='/boxopeningforcetester' element={<BoxOpening />} />
        <Route path='/box-compression-tester' element={<BoxCompressionTester />} />
        <Route path='/horizontal-peel-force-testing' element={<HorizontalPeelforceTesting />} />
        <Route path='/torque-testing-machine' element={<TorqueTestingMachine />} />
        <Route path='/electronic-drop-dart-impact-tester' element={<ElectronicDropDartImpactTester />} />
        <Route path='/manual-roller-sample-preparation' element={<ManualRollerSamplePreparation />} />
        <Route path='/martindale-abrasion-tester' element={<MartindaleAbrasionTester />} />
        <Route path='/abrasion-tester' element={<AbrasionTester />} />
        <Route path='/hydrostatic-header-tester' element={<HydrostaticHeadTester />} />
        <Route path='/yarn-inspector' element={<YarnInspector />} />





        {/* separate pages routes of R&D */}

        <Route path='/chargeanalyzersystem' element={<RDChargeAnalyzerSystem />} />
       
        <Route path='/particlesize' element={<ParticleSizeAnalyser />} />
        <Route path='/particlesizemeasurement' element={<ParticlesizeMeasurement />} />
        <Route path='/PSIHP' element={<PSIHighPressure />} />
        <Route path='/DBV' element={<DigitalBenchtopViscometer />} />
        <Route path='/APOFP' element={<ArtPhotonics />} />

        {/* separate pages routes of industrial  */}

        <Route path='/processviscometer' element={<Processviscometer />} />
        <Route path='/sofluxEV' element={<ExtrusionViscometer />} />
        <Route path='/coatingviscometer' element={<CoatingViscometer />} />
        <Route path='/ureaANA' element={<UreaAmmonium />} />
        <Route path='/highpressvidcometer' element={<HighPressViscometer />} />
        <Route path='/FPA' element={<FertilizerProcessAnalyser />} />
        <Route path='/EMTM' element={<ElectroMechanicalMaterial />} />
        <Route path='/drumabrasiontester' element={<DrumAbrasionTester />} />
        <Route path='/PMSC' element={<PneumaticManualSampleCutter />} />
        <Route path='/reboundresiliencetester' element={<ReboundResilienceTester />} />
        <Route path='/BasiccomputrizedMI' element={<BasicComputerizedMeltIndexer />} />
        <Route path='/opacitymeterPI' element={<OpacityMeterPlasticFlim />} />
        <Route path='/softingpointtester' element={<SoftingPointTester />} />
        <Route path='/FDWIT' element={<FallingDropWeight />} />
        <Route path='/penetrationtestanalyser' element={<PenetrationTest />} />
        <Route path='/bloomtester' element={<GelBloomTester />} />
        <Route path='/backextractiontester' element={<BackExtractionTester />} />
        <Route path='/notchingmachine' element={<NotchingMachine />} />
        <Route path='/pendulumtester' element={<PendulumImpactTester />} />
        <Route path='/purearthrarematerial' element={<PureEarthRareMaterial />} />

        {/* separate pages routes of water waste */}
        <Route path='/co2tester' element={<CO2Tester />} />
        <Route path='/ammoniumprob' element={<AmmoniumProb />} />
        <Route path='/ammonolab' element={<AmmonoLab />} />
        <Route path='/codbod' element={<CODMonitor />} />


        {/* separate pages routes of textile testing */}

        <Route path='/textileinstruments' element={<Textile />} />
        <Route path='/textileinstruments/tactilesensation' element={<TactileSensation />} />
        <Route path='/textileinstruments/absorbencytester' element={<AbsorbencyTester />} />
        <Route path='/textileinstruments/chargeanalyserfibrepotential' element={<ChargeAnalyserFibrePotential />} />
        <Route path='/textileinstruments/surfacehardnessabrasiontester' element={<SurfaceHardnessAbrasionTester />} />
        <Route path='/textileinstruments/electroniccrockmeter' element={<ElectronicCrockMeter />} />
        <Route path='/textileinstruments/pillingtester' element={<PillingTester />} />
        <Route path='/textileinstruments/textileabrasiontester' element={<TextileAbrasionTester />} />
        <Route path='/textileinstruments/textilemartindaleabrasiontester' element={<TextileMartindaleAbrasionTester />} />
        <Route path='/textileinstruments/opticalfilmabrasiontester' element={<OpticalFilmAbrasionTester />} />
        <Route path='/textileinstruments/dyeingrubbingtester' element={<DyeingRubbingTester />} />
        <Route path='/textileinstruments/hydrostaticheadtestertarpaulin' element={<HydrostaticHeadTesterTarpaulin />} />
        <Route path='/textileinstruments/textilehydrostaticheadtester' element={<TextileHydrostaticHeadTester />} />
        <Route path='/textileinstruments/motortwistcounteryarn' element={<MotorTwistCounterYarn />} />
        <Route path='/textileinstruments/yarninspectormotor' element={<YarnInspectorMotor />} />
        <Route path='/textileinstruments/universalmaterialstestingmachine' element={<UniversalMaterialsTestingMachine />} />


      </Routes>
    </Router>
  )
}

export default App
